import { createContext } from 'react';
import type { CheckoutConfirmationContextType } from './CheckoutConfirmationContextType';

export const CheckoutConfirmationContext = createContext<CheckoutConfirmationContextType>({
  orderLayout: undefined,
  orderDataLoading: false,
  orderData: undefined,
});
